import { render } from "./dialogSearchCustomer.vue?vue&type=template&id=ca384e58&scoped=true"
import script from "./dialogSearchCustomer.vue?vue&type=script&lang=js"
export * from "./dialogSearchCustomer.vue?vue&type=script&lang=js"

import "./dialogSearchCustomer.vue?vue&type=style&index=0&id=ca384e58&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca384e58"]])

export default __exports__